export default __webpack_public_path__ + "static/manchester-psychedelic-community@2x-60e99acbf2534048358260bf26569f4c.png";